import React, { useEffect } from "react";

const modalOverlayStyle = {
  position: "fixed",
  top: 0, left: 0, right: 0, bottom: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000
};

const modalBoxStyle = {
  background: "white",
  padding: "24px",
  borderRadius: "8px",
  minWidth: "350px",
  boxShadow: "0 2px 12px rgba(0,0,0,0.2)"
};

function Modal({ isOpen, onClose, children, closeOnOverlayClick = false, overlayClassName = '', contentClassName = '' }) {
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div style={modalOverlayStyle} className={overlayClassName} onClick={handleOverlayClick}>
      <div style={modalBoxStyle} className={contentClassName} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}

export default Modal;